<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPayments',

  created () {
    this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.invoiceHistory.subedition')}`)
  }
}
</script>
